import axiosInstance from '../../utils/axios';

export const travellerFeedbackService = {
  // Get all feedbacks for an agent
  getFeedbacks: async (agentId) => {
    try {
      const response = await axiosInstance.get(`/agent/feedback/${agentId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch feedback' };
    }
  },

  // Get feedback statistics & analytics
  getFeedbackAnalytics: async (agentId) => {
    try {
      const response = await axiosInstance.get(`/agent/feedback/${agentId}/analytics`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch feedback analytics' };
    }
  }
};

// Backward-compatibility export
export const feedbackService = travellerFeedbackService;

export default travellerFeedbackService;
